enum KeyCode {
  ESC = 27,
  SPACE_BAR = 32,
  LEFT_ARROW = 37,
  RIGHT_ARROW = 39,
}
export default KeyCode
